import React from 'react';
import { useNavigate } from 'react-router-dom';
import StepCarousel from './StepCarousel';

const OptionalStepsSection: React.FC = () => {
  const navigate = useNavigate();
  const optionalSteps = [
    {
      id: 1,
      title: "Policies & House Rules",
      description: "Turn on pet, smoking, guest, and quiet-hours policies only when you need the extra guardrails.",
      screenshot: "/lease_form_screenshots/Property_Policies.png",
      benefits: ["Avoid misunderstandings", "Document rule acknowledgements", "Protect shared spaces"]
    },
    {
      id: 2,
      title: "Utilities & Services",
      description: "Clarify who pays for each utility, service, or subscription so billing never becomes a surprise.",
      screenshot: "/lease_form_screenshots/Utilities_Services.png",
      benefits: ["Prevent billing disputes", "Track reimbursements", "Align expectations from day one"]
    },
    {
      id: 3,
      title: "Features & Amenities",
      description: "Showcase amenities, parking, storage, and included appliances to highlight the value of your property.",
      screenshot: "/lease_form_screenshots/Property_Features_Amenities.png",
      benefits: ["Market premium amenities", "Reduce tenant questions", "Document included items"]
    },
    {
      id: 4,
      title: "California Disclosures",
      description: "Add optional disclosures and notices beyond the required baseline to cover unique property situations.",
      screenshot: "/lease_form_screenshots/California_Disclosures.png",
      benefits: ["Support compliance checks", "Address local ordinances", "Reduce surprises later"]
    },
    {
      id: 5,
      title: "Additional Terms & Attachments",
      description: "Include custom clauses, addenda, or uploaded documents for special arrangements and add-ons.",
      screenshot: "/lease_form_screenshots/Additional_Terms_Communication.png",
      benefits: ["Capture unique agreements", "Support addenda", "Centralize documentation"]
    }
  ];

  return (
    <div style={{
      background: '#ffffff',
      padding: '80px 0',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 24px'
      }}>
        {/* Section Header */}
        <div className="optional-steps-header" style={{
          textAlign: 'center',
          marginBottom: '60px'
        }}>
          <h2 className="optional-steps-title" style={{
            fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
            fontWeight: 700,
            color: '#0A0B0D',
            marginBottom: '24px',
            letterSpacing: '-0.02em'
          }}>
            <span style={{ color: '#0052FF' }}> Customize</span> your lease with optional steps
          </h2>
          <p className="optional-steps-subtitle" style={{
            fontSize: 'clamp(1.2rem, 2.6vw, 1.4rem)',
            color: '#3A3F4C',
            maxWidth: '640px',
            margin: '0 auto',
            lineHeight: 1.7
          }}>
            Tailor your lease with optional policies, utilities, features, amenities, disclosures, and <span style={{ color: '#0052FF' }}>more</span>!
          </p>
        </div>

        {/* Carousel */}
        <StepCarousel
          steps={optionalSteps}
          badgeText="Optional"
          featuresLabel="Benefits"
        />

        {/* CTA */}
        <div style={{
          textAlign: 'center',
          marginTop: '80px',
          padding: '60px 40px',
          background: 'linear-gradient(135deg, #F8F9FF 0%, #E7F3FF 100%)',
          borderRadius: '24px'
        }}>
          <h3 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#0A0B0D',
            marginBottom: '16px'
          }}>
            Ready to create a professional lease?
          </h3>
          <p style={{
            fontSize: '1.125rem',
            color: '#5B616E',
            marginBottom: '32px'
          }}>
            Include only the sections you need, or use them all for maximum protection.
          </p>
          <button
            type="button"
            style={{
              padding: '16px 32px',
              background: '#0052FF',
              color: 'white',
              border: 'none',
              borderRadius: '999px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onClick={() => navigate('/signup')}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#0041CC';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#0052FF';
            }}
          >
            Start customizing →
          </button>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .optional-steps-header {
            margin-bottom: 60px !important;
            padding: 0 20px !important;
          }

          .optional-steps-title {
            font-size: 2.5rem !important;
            margin-bottom: 20px !important;
          }

          .optional-steps-subtitle {
            font-size: 1rem !important;
            padding: 0 10px !important;
          }
        }

        @media (max-width: 480px) {
          .optional-steps-header {
            margin-bottom: 40px !important;
            padding: 0 16px !important;
          }

          .optional-steps-title {
            font-size: 2rem !important;
            margin-bottom: 16px !important;
          }

          .optional-steps-subtitle {
            font-size: 1rem !important;
            padding: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default OptionalStepsSection;
